import React, { useEffect, useState } from "react";
import { listStudentCurrentAssignments } from "../../services/authService";

// Widget compact "Programme(s) en cours" pour la vue stats élève. Affiche
// TOUTES les assignations actives (un élève peut suivre 2 programmes en
// parallèle — rare mais toléré) avec barre de progression temporelle.
// Cliquable → bascule sur l'éditeur > panneau Ses programmes pour agir.

const DAY_MS = 86400000;

function currentWeek(dateDebut, dureeSemaines) {
	const now = Date.now();
	if (now < dateDebut) return 0;
	const daysIn = Math.floor((now - dateDebut) / DAY_MS);
	return Math.min(dureeSemaines, Math.floor(daysIn / 7) + 1);
}
function progressionPct(dateDebut, dateFin) {
	const now = Date.now();
	if (now <= dateDebut) return 0;
	if (now >= dateFin) return 100;
	return Math.round(((now - dateDebut) / (dateFin - dateDebut)) * 100);
}
const fmtShort = (ts) => new Date(Number(ts)).toLocaleDateString("fr-FR", { day: "numeric", month: "short" });

export default function StudentActiveProgramsWidget({ student, refreshKey, onOpenDetail }) {
	const [assignments, setAssignments] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!student?.id) return;
		let cancelled = false;
		setLoading(true);
		listStudentCurrentAssignments(student.id).then((res) => {
			if (cancelled) return;
			if (res.success) setAssignments(res.assignments);
			setLoading(false);
		});
		return () => { cancelled = true; };
	}, [student?.id, refreshKey]);

	if (loading || assignments.length === 0) return null;  // widget silencieux si rien à montrer

	return (
		<div className="sp-widget">
			<div className="sp-widget-head">
				<span className="sp-widget-label">Programme{assignments.length > 1 ? "s" : ""} en cours</span>
				<span className="sp-widget-count">{assignments.length}</span>
			</div>
			<div className="sp-widget-list">
				{assignments.map((a) => {
					const week = currentWeek(a.dateDebut, a.dureeSemaines);
					const pct = progressionPct(a.dateDebut, a.dateFin);
					return (
						<button
							key={a.idAssignation}
							type="button"
							className="sp-widget-card"
							onClick={() => onOpenDetail?.(a)}
							title="Ouvrir le détail (éditeur > Ses programmes)"
						>
							<div className="sp-widget-card-line1">
								<span className="sp-widget-card-name">{a.programmeNom}</span>
								<span className="sp-widget-card-week">
									S{week}/{a.dureeSemaines}
								</span>
							</div>
							<div className="sp-widget-progress" aria-hidden="true">
								<div className="sp-widget-progress-fill" style={{ width: `${pct}%` }} />
							</div>
							<div className="sp-widget-card-line2">
								<span>{fmtShort(a.dateDebut)} → {fmtShort(a.dateFin)}</span>
								<span className="sp-widget-card-pct">{pct}%</span>
							</div>
						</button>
					);
				})}
			</div>
		</div>
	);
}
